import React from "react";
import { useDispatch } from "react-redux";
import { Field } from "formik";

import { NoteInput } from "components/inputs/text-input";
import Form from "components/form";
import { showMessage } from "app/store/actions";
import { removeReferralSourceDocumentAction } from "app/main/referrals/actions";

/**
 * Form component for removing a referral source document
 */
const RemoveSourceDocumentForm = ({
  orgUnitId,
  referralId,
  sourceDocumentId,
  schema,
  onSucceed,
  contentProps,
}) => {
  const dispatch = useDispatch();

  /**
   * Handle form submission for source document removal
   * @param {Object} values - Form values containing remove reason
   * @param {Object} formikBag - Formik helper methods
   */
  const handleSubmit = ({ deletion }, { setSubmitting, setErrors }) => {
    const deletePayload = {
      orgUnitId,
      referralId,
      sourceDocumentId,
      removedReason: deletion.reason,
    };

    // Dispatch the delete action
    dispatch(removeReferralSourceDocumentAction(orgUnitId, deletePayload))
      .then(response => {
        setSubmitting(false);

        if (response.error !== true) {
          // Success - call the onSucceed callback
          onSucceed(response.payload);
        } else {
          // Error - set form errors
          setErrors(response.payload);

          const errorMessage = response.payload.exceptionMessage || "Failed to remove referral source document";

          // Show error message
          dispatch(showMessage({
            message: errorMessage,
            variant: "error",
          }));
        }
      });
  };

  // Initialize form values from schema
  const initialValues = schema.cast();

  return (
    <Form
      initialValues={initialValues}
      onSubmit={handleSubmit}
      submitLabel="Remove"
      validationSchema={schema}
      variant="filled"
      contentProps={contentProps}
      content={() => (
        <>
          {/* Warning message about deletion being permanent */}
          <div style={{
            marginBottom: 16,
            padding: 12,
            backgroundColor: "#fff3cd",
            border: "1px solid #ffc107",
            borderRadius: 4,
          }}
          >
            <strong>Warning:</strong> This action cannot be undone. The source document
            will be permanently removed from this referral.
          </div>

          {/* Reason input field */}
          <Field
            name="deletion.reason"
            component={NoteInput}
            label="Reason for Removal"
            icon="message"
            required
            maxLength={500}
            helperText="Please provide a reason for removing this referral source document"
          />
        </>
      )}
    />
  );
};

export default RemoveSourceDocumentForm;
